<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <!-- 제목 -->
            <sui-input-label :label="$t('MSG_TXT_TITLE')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldApprovalTitle"
              v-model="queryData.approvalTitle"
              maxlength="100"
              @keyup.enter="onClickSearchBtn"
            />
          </div>
          <div class="col-xs-1">
            <!-- 결재일 -->
            <sui-input-label :label="$t('MSG_TIT_APRV_DT')" />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="datePicker"
              v-model="queryData.approvalRangeDate"
              :hideInput="false"
              sticky
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <!-- 작성자 -->
            <sui-input-label :label="$t('MSG_TIT_DOC_CRTR')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldApprovalDraftUserName"
              v-model="queryData.approvalDraftUserName"
              maxlength="100"
              @keyup.enter="onClickSearchBtn"
            />
          </div>
          <div class="col-xs-1">
            <!-- 결재상태 -->
            <sui-input-label :label="$t('MSG_TIT_APRV_STT')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectApprovalProgressStateCode"
              v-model="queryData.approvalProgressStateCode"
              codeId="COD_APRV_PRGS_STT"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickResetBtn"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearchBtn"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridApproval"
        :columns="columnApproval"
        :dataset="'dsApproval'"
        :multiselect="true"
        :showDisplayCountControl="true"
        :initial-pagesize="10"
      />
      <div class="comm_btn_wrap">
        <!-- 현황조회 -->
        <sui-button
          v-permission:read="contextPageId"
          type="button"
          class="comm_btn_border"
          @click="onClickSearchStatus"
        >
          {{ $t('MSG_TIT_APRV_PRCO_SRCH') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import { template } from 'suneditor/src/plugins';

const APPROVAL_STATE_LIST = [
  {
    type: 'waiting',
    key: '0',
    // clickable: 'true',
    label: utils.getMessageById('MSG_TIT_HOLDON'), // '보류', $t('MSG_TIT_HOLDON')
  },
  {
    type: 'waiting',
    key: '1',
    label: utils.getMessageById('MSG_TXT_APRV_INPRGS'), // '진행중', $t('MSG_TXT_APRV_INPRGS')
  },
  {
    type: 'complete',
    key: '2',
    label: utils.getMessageById('MSG_TXT_CONC'), // '완결', $t('MSG_TXT_CONC')
  },
  {
    type: 'cancel',
    key: '3',
    label: utils.getMessageById('MSG_BTN_RJT'), // '반려', $t('MSG_BTN_RJT')
  },
  {
    type: 'cancel',
    key: '4',
    label: utils.getMessageById('MSG_BTN_APRV_CNCL'), // '상신취소', $t('MSG_BTN_APRV_CNCL')
  },
  {
    type: 'complete',
    key: '5',
    label: utils.getMessageById('MSG_TXT_APRV_ABTR'), // '전결', $t('MSG_TXT_APRV_ABTR')
  },
  {
    type: 'waiting',
    key: '6',
    label: utils.getMessageById('MSG_TXT_APRV_POST_CONC'), // '후완결', $t('MSG_TXT_APRV_POST_CONC')
  },
  {
    type: 'cancel',
    key: 'E',
    label: utils.getMessageById('MSG_TXT_APRV_SUBM_FAIL'), // '상신실패', $t('MSG_TXT_APRV_SUBM_FAIL')
  },
];

export default {
  name: 'PGE_CML_00005', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      queryData: {
        approvalDraftUserName: '',
        approvalRangeDate: {
          from: '',
          to: '',
        },
        approvalProgressStateCode: '',
        approvalTitle: '',
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dsApproval',
    type: 'local',
    datafields: [
      {
        name: 'approvalUid',
        type: 'string',
        map: 'approvalUid',
      },
      {
        name: 'approvalTitle',
        type: 'string',
        map: 'approvalTitle',
      },
      // 생성자(기안자) 정보
      {
        name: 'drafterUserId',
        type: 'string',
        map: 'drafterUserId',
      },
      {
        name: 'drafterUserName',
        type: 'string',
        map: 'drafterUserName',
      },
      {
        name: 'drafterUserGlobalName',
        type: 'string',
        map: 'drafterUserGlobalName',
      },
      {
        name: 'drafterUserEmail',
        type: 'string',
        map: 'drafterUserEmail',
      },
      {
        name: 'drafterDepartmentName',
        type: 'string',
        map: 'drafterDepartmentName',
      },
      {
        name: 'drafterDepartmentEnglishName',
        type: 'string',
        map: 'drafterDepartmentEnglishName',
      },
      {
        name: 'drafterDisplayLanguageId',
        type: 'string',
        map: 'drafterDisplayLanguageId',
      },
      {
        name: 'drafterLoginId',
        type: 'string',
        map: 'drafterLoginId',
      },
      {
        name: 'drafterKnoxId',
        type: 'string',
        map: 'drafterKnoxId',
      },
      {
        name: 'approvalDTM',
        type: 'string',
        map: 'approvalDTM',
      },
      {
        name: 'approvalDraftDTM',
        type: 'string',
        map: 'approvalDraftDTM',
      },
      {
        name: 'approvalProgressStateCode',
        type: 'string',
        map: 'approvalProgressStateCode',
      },
      {
        name: 'approvalProgressStateCodeName',
        type: 'string',
        map: 'approvalProgressStateCodeName',
      },
      // 개봉여부('Y'/'N', true/false)
      {
        name: 'isApprovalTitleBold',
        type: 'string',
        map: 'isApprovalTitleBold',
      },
    ],
  }],
  created() {
    this.columnApproval = [
      {
        // "제목"
        text: this.$t('MSG_TXT_TITLE'),
        datafield: 'approvalTitle',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickDetailLink,
            type: 'link',
            styleBoldFieldName: 'isApprovalTitleBold', // ('Y'/'N', true/false)
          }, this.dsApproval, this.$refs.gridApproval);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        // "작성자"
        text: this.$t('MSG_TIT_DOC_CRTR'),
        datafield: 'drafterUserName',
        width: 200,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'drafterDisplayLanguageId',
              userId: 'drafterUserId',
              userName: 'drafterUserName',
              userGlobalName: 'drafterUserGlobalName',
              departmentName: 'drafterDepartmentName',
              departmentEnglishName: 'drafterDepartmentEnglishName',
              loginId: 'drafterLoginId',
              knoxId: 'drafterKnoxId',
            },
          }, this.dsApproval, this.$refs.gridApproval);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      // 결재일시
      {
        text: this.$t('MSG_TIT_APRV_DTM'),
        datafield: 'approvalDTM',
        width: 200,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellDateLabel(row, column, value, htmlElement, {
            // formatOption: 'S',
          }, this.dsApproval, this.$refs.gridApproval);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      // 상신일시
      {
        text: this.$t('MSG_TIT_APRV_DRFT_DTM'),
        datafield: 'approvalDraftDTM',
        width: 200,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellDateLabel(row, column, value, htmlElement, {
            // formatOption: 'S',
          }, this.dsApproval, this.$refs.gridApproval);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      // 결재상태
      {
        text: this.$t('MSG_TIT_APRV_STT'),
        datafield: 'approvalProgressStateCode', // approvalProgressStateCodeName
        width: 100,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {
            optionList: APPROVAL_STATE_LIST,
            // handler: this.onViewApplOpn,
          }, this.dsApproval, this.$refs.gridApproval);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 기안작성 팝업 callback 함수
     */
    approvalPopupCallback(isSuccess) {
      if (isSuccess) {
        this.onClickSearchBtn();
      }
    },
    onLoad() {
      // TODO: 아래 if else 구분할 것인지 아닌지 결정
      //sonarcube codesmell 대응
      // if (this.$route.query.refresh) {
      //   this.onClickSearchBtn();
      // } else {
      //   this.onClickSearchBtn();
      // }
      this.onClickSearchBtn();
    },
    /**
     * 제목 link click event handler
     * 결재작성 팝업을 띄우고 해당 데이터를 load 한다.
     */
    onClickDetailLink(btn, selectedRow) {
      if (selectedRow && selectedRow.approvalUid) {
        const that = this;
        utils.openLayerPopup('PGE_CML_00008', isSuccess => {
          if (isSuccess && isSuccess === true) {
            that.onClickSearchBtn();
          } else {
            const targetDataRow = utils.find(that.dsApproval.getRawData(), { approvalUid: selectedRow.approvalUid });
            // that.dsApproval.setData(this.oldRowIndex, 'check', checkFalse);
            targetDataRow.isApprovalTitleBold = false;
            that.dsApproval.setRawData(that.dsApproval.getRawData());
          }
        },
        {
          pageInitialData: {
            approvalUid: selectedRow.approvalUid,
            parentPageId: this.contextPageId,
            finalModificationDTM: selectedRow.finalModificationDTM,
          },
          size: 'xlg',
        });
      }
    },
    onClickSearchBtn() {
      let approvalStartDTM = '';
      let approvalEndDTM = '';
      if (!utils.isEmpty(this.queryData.approvalRangeDate.from) && !utils.isEmpty(this.queryData.approvalRangeDate.to)) {
        approvalStartDTM = `${utils.toStringByFormat(this.queryData.approvalRangeDate.from, 'YYYYMMDD')}000000`;
        approvalEndDTM = `${utils.toStringByFormat(this.queryData.approvalRangeDate.to, 'YYYYMMDD')}235959`;
      }
      const dataParams = {
        approvalTitle: this.queryData.approvalTitle,
        approvalStartDTM,
        approvalEndDTM,
        approvalDraftUserName: this.queryData.approvalDraftUserName,
        approvalProgressStateCode: this.queryData.approvalProgressStateCode,
      };
      http.request(this.contextPageId, 'DTS_CML_00013', {
        query: dataParams,
      }).then(res => {
        utils.forEach(res.data, curApproval => {
          // 결재자, 작성자 정보 발췌
          if (curApproval.approvalUserList.length > 0) {
            // 작성자(기안자) 정보 발췌
            // 각 결재건의 결재선(결재자목록) 에서 첫번째 혹은 approvalOrder === 0 인 결재자 정보
            utils.set(curApproval, 'drafterDepartmentEnglishName', curApproval.approvalUserList[0].approvalDepartmentEnglishName);
            utils.set(curApproval, 'drafterDepartmentName', curApproval.approvalUserList[0].approvalDepartmentName);
            utils.set(curApproval, 'drafterUserGlobalName', curApproval.approvalUserList[0].approvalUserGlobalName);
            utils.set(curApproval, 'drafterUserName', curApproval.approvalUserList[0].approvalUserName);
            utils.set(curApproval, 'drafterUserId', curApproval.approvalUserList[0].approvalUserId);
            utils.set(curApproval, 'drafterUserEmail', curApproval.approvalUserList[0].approvalUserEmail);
            utils.set(curApproval, 'drafterDisplayLanguageId', curApproval.approvalUserList[0].userDisplayLanguageId);
            utils.set(curApproval, 'drafterLoginId', curApproval.approvalUserList[0].loginId);
            utils.set(curApproval, 'drafterKnoxId', curApproval.approvalUserList[0].knoxId);
          }
          // 개봉여부 발췌(결재선 중 로그인자의 개봉여부)
          const curUser = utils.find(curApproval.approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
          utils.set(curApproval, 'isApprovalTitleBold', curUser.approvalUnsealYn !== 'Y');
          // 결재일시 발췌
          utils.set(curApproval, 'approvalDTM', curUser.approvalDTM);
        });
        this.dsApproval.setRawData(res.data.sort((a, b) => {
          const dtm1 = a.approvalDTM * 1;
          const dtm2 = b.approvalDTM * 1;
          if (dtm1 >= dtm2) return true;
          return false;
        }));
      });
    },
    onClickResetBtn() {
      this.queryData.approvalTitle = '';
      this.queryData.approvalRangeDate = {
        from: '',
        to: '',
      };
      this.queryData.approvalDraftUserName = '';
      this.$refs.codeSelectApprovalProgressStateCode.reset();
    },
    /**
     * 현황조회
     */
    onClickSearchStatus() {
      if (this.dsApproval.getSelectedIndexes().length === 0 || this.dsApproval.getSelectedIndexes().length > 1) {
        // '하나의 항목만 선택하세요.'
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_SELT_ONE_ITEM'));
      } else {
        utils.openLayerPopup('PGE_CML_00013', this.approvalPopupCallback, {
          pageInitialData: {
            approvalUid: this.dsApproval.getSelectedRow().approvalUid,
          },
          size: 'xlg',
        });
      }
    },
    // TODO: rename
    aprvPopupCallback(objAprv) {
      if (utils.isEmpty(objAprv) === false) {
        this.aprvData = objAprv;
      }
    },
  },
};
</script>

<style scoped>
</style>
